import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  stickyBlock: {
    position: "fixed",
    bottom: 0,
    left: "24px",
    maxWidth: "460px",
    backgroundColor: "rgba(0,0,0,0)",
    textAlign: "center",
    maxHeight: "250px",
    overflowY: "auto",
    opacity: "1",
    zIndex: theme.zIndex.drawer + 9999,
    boxShadow: "none",
  },

  spinner: {
    color: theme.palette.primary.main,
    marginRight: "18px",
  },

  successIcon: {
    color: "green",
    marginRight: "18px",
  },

  errorIcon: {
    color: "red",
    marginRight: "18px",
  },

  listItem: {
    backgroundColor: "#616161",
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.2)",
    marginBottom: "5px",
    borderRadius: "4px",
    color: "white",
  },
}));
